import { z } from 'zod'

/***************** 진행 상태 *****************/
// 스킵 횟수가 3 이상이 되면 서버가 SKIPPED 로 바꾼다. 전체 관리 상태와 콘텐츠별 진행 상태가 같은 값을 쓴다.
export const ONBOARDING_STATUS = ['NOT_STARTED', 'IN_PROGRESS', 'COMPLETED', 'SKIPPED'] as const

/***************** 온보딩 콘텐츠 *****************/
// 서버는 name 을 DB 의 문자열로 내지만, 앱은 이름마다 진입 화면·트래킹 문구를 붙여 쓰므로 아는 이름만 받는다.
// 새 콘텐츠가 DB 에 추가되면 이 목록에도 더해야 dev 에서 응답이 통과한다.
export const ONBOARDING_CONTENT_NAME = [
  'CREATE_CONCEPT_WORKSHEET',
  'CREATE_PUBLIC_WORKSHEET',
  'CREATE_SCHOOL_TEST_WORKSHEET',
  'CREATE_PAPER_WORKSHEET',
  'ASSIGN_AND_PRINT_WORKSHEET',
  'SCORING_ANSWER',
  'MANAGE_WRONG_ANSWER',
  'CREATE_SIGNATURE_WORKSHEET',
  'INCOME_PARENT_PAYMENT',
] as const

export const OnboardingStatusSchema = z.enum(ONBOARDING_STATUS)
export type OnboardingStatus = z.infer<typeof OnboardingStatusSchema>

export const OnboardingContentNameSchema = z.enum(ONBOARDING_CONTENT_NAME)
export type OnboardingContentName = z.infer<typeof OnboardingContentNameSchema>

// 2026-10-14 백엔드 develop(6a0f8e7bb) 의 onboarding/controller/response/OnboardingContentResponse.kt 로 확인.
export const OnboardingContentSchema = z.object({
  id: z.number(),
  status: OnboardingStatusSchema,
  name: OnboardingContentNameSchema,
  /** 가이드(iorad) 페이지 주소 */
  url: z.string(),
  skipCount: z.number(),
})
export type OnboardingContent = z.infer<typeof OnboardingContentSchema>

/** 사용자 전체 온보딩 관리 상태와 요금제로 거른 콘텐츠 목록. 관리 상태가 없거나 COMPLETED 면 목록이 비어 온다 */
export const OnboardingContentsSchema = z.object({
  status: OnboardingStatusSchema,
  onboardings: z.array(OnboardingContentSchema),
})
export type OnboardingContents = z.infer<typeof OnboardingContentsSchema>

export const OnboardingVisibilitySchema = z.object({
  visibility: z.boolean(),
})
export type OnboardingVisibility = z.infer<typeof OnboardingVisibilitySchema>

/***************** 온라인 온보딩(아카데미) *****************/
// 큐브메이커 랜딩으로 보낼 주소. 서버가 SSO 토큰을 `token` 파라미터로 붙이고, 돌아갈 주소를 안 주면 기본 랜딩을 채운다
export const OnlineOnboardingRedirectSchema = z.object({
  redirectUrl: z.string(),
})
export type OnlineOnboardingRedirect = z.infer<typeof OnlineOnboardingRedirectSchema>
